module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pluralo d-flex"
  }, [_c('pill'), _vm._v(" "), _c('sidebar'), _vm._v(" "), _c('section', {
    staticClass: "d-flex flex-column fix-index"
  }, [_c('div', [_c('bar'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.displayGlobalMessage && !_vm.getIsDonwloadingCompanySettings) ? _c('AlertMessage', {
    attrs: {
      "message": "Your profile is missing mandatory billing information. Please update your details to proceed.",
      "icon": "ico-alert",
      "bold": ""
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('router-view', {
    staticClass: "flexGrow1",
    nativeOn: {
      "click": function($event) {
        return _vm.clickOnContentArea()
      }
    }
  })], 1), _vm._v(" "), _c('modal-wrapper'), _vm._v(" "), (_vm.showNotifications) ? _c('floating-notifications') : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-05e4d8c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e4d8c2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Pluralo.vue
// module id = 2345
// module chunks = 0